import styled from 'styled-components';

export const EmailVerificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  text-align: center;
  padding: 40px 20px;
  background: ${(p) => p.theme.white};
  border-radius: 12px;
  margin: 0 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #e2e8f0;
`;

export const EmailVerificationTitle = styled.h2`
  color: #0600B4;
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 15px 0;
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
`;

export const EmailVerificationMessage = styled.p`
  color: #6b7280;
  font-size: 16px;
  margin: 0 0 30px 0;
  line-height: 1.5;
  max-width: 500px;
  font-family: "Figtree", ui-sans-serif, system-ui, -apple-system, "system-ui", "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;

  strong {
    color: #0600B4;
    font-weight: 600;
  }
`;